import { Component, Prop, Inject, Watch } from 'vue-property-decorator';
import Vue2Filters from 'vue2-filters';
import { TipoRevision } from '@/shared/model/enumerations/tipo-revision.model';
import { mixins } from 'vue-class-component';
import SolucionMixin from '../mixins/solucion-mixin';
import { IRevision } from '@/shared/model/revision.model';
import { mapMutations } from 'vuex';
import { TipoComision } from '@/shared/model/enumerations/tipo-comision.model';
import { Solicitud } from '@/shared/model/solicitud.model';
import { EstadoRevision } from '@/shared/model/enumerations/estado-revision.model';
import SolicitudMixin from '../mixins/solicitud-mixin';
import RevisionMixin from '../mixins/revision-mixin';
import { Solucion } from '@/shared/model/solucion.model';
import HomeMenuComponent from '@/components/home-menu/home-menu.component';

@Component({
  mixins: [Vue2Filters.mixin],
  methods: {
    ...mapMutations(['setEvaluacion', 'setDictamen', 'setRevisorSeleccionado']),
  },
})
export default class EvaluacionesIndividuales2026Component extends mixins(SolucionMixin, SolicitudMixin, RevisionMixin, HomeMenuComponent) {
  @Prop({ required: true })
  public solicitud: Solicitud;

  @Prop({ required: true })
  public revision;

  public evaluacionId: string;
  public plenariaId: string;

  public revisiones: Array<IRevision> = [];

  public revisada = EstadoRevision.REVISADA;

  public aceptada = EstadoRevision.ACEPTADA;

  public confirmaClonacion = '';

  /**
   * Mutación para guardar la evaluación seleccionada
   */
  setEvaluacion!: (evaluacion: any) => void;

  /**
   * Mutación para guardar el dictamen seleccionada
   */
  setDictamen!: (dictamen: any) => void;

  /**
   * Mutación para guardar el revisor seleccionado
   */
  setRevisorSeleccionado!: (revisionSeleccionada: number) => void;

  mounted(): void {
    this.get();
    this.retriveSolucionById();
  }

  /**
   * Carga inicial del componente
   *
   * @memberof EvaluacionesIndividualesComponent
   */
  public get(): void {
    if (this.solicitud && this.revision) {
      (this.clonado = this.revision?.respuesta?.clonado),
        (this.evaluacionGuardadaFinal = this.revision?.respuesta?.evaluacionGuardadaFinal),
        this.getDefinicionRevision(this.solicitud.solucionId);
    }
  }

  /**
   *Obtiene las definiciones de una revisión
   *
   * @memberof EvaluacionesIndividualesComponent
   */
  @Watch('definicionEvaluacion')
  public getDefiniciones() {
    if (this.solicitud?.reconsideracion) {
      this.plenariaId = this.getDefinicionByTipoComision(TipoRevision.PLENARIA, TipoComision.RECONSIDERACION);
      this.evaluacionId = this.getDefinicionByTipoComision(TipoRevision.INDIVIDUAL, TipoComision.RECONSIDERACION);
    } else {
      this.plenariaId = this.getDefinicionByTipoComision(TipoRevision.PLENARIA, TipoComision.DICTAMINADORA);
      this.evaluacionId = this.getDefinicionByTipoComision(TipoRevision.INDIVIDUAL, TipoComision.DICTAMINADORA);
    }
    this.getTodasRevisiones();
  }

  /**
   *Obtiene las revisiones de una solicitud del cuestionario evaluación individual
   *
   * @memberof EvaluacionesIndividualesComponent
   */
  public getTodasRevisiones() {
    this.revisionService()
      .getAllRevisionesBySolicitudId(this.solicitud.id, this.evaluacionId)
      .then(revisiones => {
        // Filtrar las revisiones por el estado revisada
        this.revisiones = revisiones.filter(revision => revision.estado === this.revisada);
      })
      .catch(err => {});
  }

  /**
   * Establece la evaluación y dictamen de un evaluador en el store para ser recuperado en la evaluación plenaria.
   * Dirige a la evaluación plenaria con un evento de clic
   * @param revision la revisión seleccionada
   */
  public seleccionarRevision(revision: any, index: number) {
    // Mostrar la información de la revisión seleccionada
    this.setEvaluacion(revision?.respuesta?.evaluacion);

    this.setRevisorSeleccionado(index + 1);

    this.guardarEvaluacionPleno(revision);

    // simular clic con javascript para llevarte al siguiente paso.
    document.querySelector('#sidebar-wrapper > div > ul > li:nth-child(6) > a').dispatchEvent(new Event('click'));
  }

  public retriveSolucionById() {
    const id = this.solicitud.solucionId ?? '';
    this.solucionService()
      .find(id)
      .then(res => {
        this.solucionPlenaria = res;
      })
      .catch(error => {});
  }

  /**
   * Método para guardar la evaluación de una revisión.
   * @param revision la revisión que contiene la información.
   */
  public guardarEvaluacionPleno(revision: any): void {
    let revisionPleno = {};
    this.recomendado = revision?.respuesta?.evaluacion;

    if (revision?.respuesta?.resultadoCualitativoSegunda) {
      this.resultadoCualitativoSegunda = revision?.respuesta?.resultadoCualitativoSegunda;
    } else if (revision?.respuesta?.resultadoCualitativoPrimera) {
      this.resultadoCualitativoPrimera = revision?.respuesta?.resultadoCualitativoPrimera;
    }

    this.calcularPrelacion2026();

    revisionPleno = {
      evaluacion: revision?.respuesta?.evaluacion,
      dictamen: revision?.respuesta?.dictamen,
      resumen: this.resumen,
      // PRIMER VUELTA
      evaluacion1: revision?.respuesta?.evaluacion1,
      totalResultadoCualitativoPrimera: revision?.respuesta?.totalResultadoCualitativoPrimera,
      resultadoCualitativoPrimera: revision?.respuesta?.resultadoCualitativoPrimera,
      valoracionesCualitativasPrimera: revision?.respuesta?.valoracionesCualitativasPrimera,
      evaluacionGuardada1: revision?.respuesta?.evaluacionGuardada1,
      // SEGUNDA VUELTA
      evaluacion2: revision?.respuesta?.evaluacion2,
      totalResultadoCualitativoSegunda: revision?.respuesta?.totalResultadoCualitativoSegunda,
      resultadoCualitativoSegunda: revision?.respuesta?.resultadoCualitativoSegunda,
      valoracionesCualitativasSegunda: revision?.respuesta?.valoracionesCualitativasSegunda,
      segundaOportunidadActiva: revision?.respuesta?.segundaOportunidadActiva,
      evaluacionGuardada2: revision?.respuesta?.evaluacionGuardada2,

      evaluacion3: revision?.respuesta?.evaluacion3,
      nivelExcepcion: revision?.respuesta?.nivelExcepcion,
      esExcepcion: revision?.respuesta?.esExcepcion,
      evaluacionGuardadaFinal: revision?.respuesta?.evaluacionGuardadaFinal,
    };
    this.guardaEvaluacion(revisionPleno);
  }

  /**
   * Verifica si la revisión está en estado 'aceptada'.
   */
  public get estadoPleno(): boolean {
    return this.revision?.estado === this.aceptada;
  }

  public confirmarClonado(valor: string): void {
    if (valor === 'SI') {
      this.clonado = true;
      this.confirmaClonacion = 'SI';
    } else if (valor === 'NO') {
      this.clonado = false;
      this.confirmaClonacion = 'NO';
      // simular clic con javascript para llevarte al siguiente paso.
      document.querySelector('#sidebar-wrapper > div > ul > li:nth-child(6) > a').dispatchEvent(new Event('click'));
    }

    let datosEnviar = {};

    datosEnviar = {
      confirmaClonacion: this.confirmaClonacion,
      clonado: this.clonado,
    };
    this.guardaEvaluacion(datosEnviar);
  }
}
